import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { products } from '../../mocks/products';
import { useCart } from '../../contexts/CartContext';

export default function HomePage() {
  const { addToCart } = useCart();

  const featuredProducts = products.slice(0, 4);

  return (
    <div className="min-h-screen">
      <Navbar transparent />

      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/22148104aa0409113a66cf8f1182c88a.jpg"
          alt="Nueva Colección Otoño Invierno"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
        
        <div className="relative z-10 text-white max-w-7xl mx-auto px-4 md:px-8 w-full">
          <h1 className="text-4xl md:text-8xl font-light tracking-tight mb-6 md:mb-8 leading-tight">
            NUEVA<br />
            COLECCIÓN<br />
            OTOÑO INVIERNO
          </h1>
          
          <div className="flex flex-col md:flex-row gap-4 md:gap-8 mt-8 md:mt-16">
            <div className="bg-black/40 backdrop-blur-sm px-4 md:px-6 py-3 md:py-4 rounded-2xl max-w-xs">
              <p className="text-xs md:text-sm leading-relaxed">
                Descubre las últimas tendencias en moda femenina con nuestra nueva colección otoño-invierno 2025.
              </p>
            </div>
            <div className="bg-black/40 backdrop-blur-sm px-4 md:px-6 py-3 md:py-4 rounded-2xl max-w-xs">
              <p className="text-xs md:text-sm leading-relaxed">
                Prendas elegantes y versátiles diseñadas para la mujer moderna que busca estilo y comodidad.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-24 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-light text-center mb-8 md:mb-16">
            Descubre tu estilo <span className="inline-block">✨</span>
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            <Link
              to="/catalogo"
              className="group relative h-64 md:h-96 rounded-3xl overflow-hidden cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20flowing%20dresses%20collection%20on%20minimalist%20display%20with%20soft%20natural%20lighting%20and%20clean%20white%20background%2C%20luxury%20fashion%20photography%2C%20sophisticated%20feminine%20style%2C%20professional%20product%20presentation&width=500&height=700&seq=cat1&orientation=portrait"
                alt="Vestidos"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-4 md:bottom-8 left-4 md:left-8 text-white">
                <h3 className="text-2xl md:text-3xl font-light mb-1 md:mb-2">Vestidos</h3>
                <p className="text-xs md:text-sm text-white/90">Elegancia atemporal</p>
              </div>
            </Link>

            <Link
              to="/catalogo"
              className="group relative h-64 md:h-96 rounded-3xl overflow-hidden cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=casual%20chic%20women%20clothing%20collection%20with%20modern%20comfortable%20pieces%20on%20clean%20minimal%20background%2C%20contemporary%20fashion%20photography%2C%20relaxed%20elegant%20style%2C%20professional%20display&width=500&height=700&seq=cat2&orientation=portrait"
                alt="Casual Chic"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-4 md:bottom-8 left-4 md:left-8 text-white">
                <h3 className="text-2xl md:text-3xl font-light mb-1 md:mb-2">Casual Chic</h3>
                <p className="text-xs md:text-sm text-white/90">Comodidad con estilo</p>
              </div>
            </Link>

            <Link
              to="/catalogo"
              className="group relative h-64 md:h-96 rounded-3xl overflow-hidden cursor-pointer"
            >
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20fashion%20accessories%20collection%20including%20bags%20and%20jewelry%20on%20minimalist%20white%20background%2C%20luxury%20product%20photography%2C%20sophisticated%20style%2C%20professional%20presentation&width=500&height=700&seq=cat3&orientation=portrait"
                alt="Accesorios"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-4 md:bottom-8 left-4 md:left-8 text-white">
                <h3 className="text-2xl md:text-3xl font-light mb-1 md:mb-2">Accesorios</h3>
                <p className="text-xs md:text-sm text-white/90">Detalles que marcan</p>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-24 px-4 md:px-8 bg-gray-50" data-product-shop>
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-light text-center mb-2 md:mb-4">Productos Destacados</h2>
          <p className="text-center text-gray-600 mb-8 md:mb-16 text-sm md:text-base">Las piezas más populares de nuestra colección</p>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
            {featuredProducts.map((product, index) => {
              const bgColors = ['bg-rose-100', 'bg-emerald-100', 'bg-gray-100', 'bg-amber-50'];
              return (
                <div
                  key={product.id}
                  className={`${bgColors[index]} rounded-[24px] md:rounded-[40px] overflow-hidden shadow-sm hover:shadow-lg transition-shadow`}
                >
                  <div className="aspect-[3/4] p-3 md:p-6">
                    <div className="w-full h-full">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-cover rounded-2xl md:rounded-3xl"
                      />
                    </div>
                  </div>
                  <div className="bg-white px-3 md:px-6 py-3 md:py-5">
                    <h3 className="font-medium text-gray-900 mb-1 text-xs md:text-base">{product.name}</h3>
                    <p className="text-lg md:text-2xl font-light text-gray-900 mb-2 md:mb-3">${product.price}</p>
                    <button
                      onClick={() => addToCart(product)}
                      className="w-full py-1.5 md:py-2 text-xs md:text-sm text-gray-700 hover:text-gray-900 transition-colors whitespace-nowrap"
                    >
                      Agregar al carrito
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="text-center mt-8 md:mt-12">
            <Link
              to="/catalogo"
              className="inline-block px-6 md:px-8 py-2.5 md:py-3 bg-[#F2C4CE] text-gray-900 rounded-full hover:bg-[#e8adb8] transition-colors text-xs md:text-sm whitespace-nowrap"
            >
              Ver Todo el Catálogo
            </Link>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-24 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-center">
            <div className="h-[400px] md:h-[600px]">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20fashion%20boutique%20interior%20with%20modern%20minimalist%20design%20and%20soft%20natural%20lighting%2C%20luxury%20retail%20space%20showcasing%20women%20clothing%2C%20sophisticated%20ambiance%2C%20professional%20photography%2C%20warm%20neutral%20tones&width=700&height=900&seq=about1&orientation=portrait"
                alt="Sobre NIN"
                className="w-full h-full object-cover rounded-[24px] md:rounded-[35px] shadow-lg"
              />
            </div>

            <div>
              <div className="inline-block bg-blue-100 text-blue-900 px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm mb-4 md:mb-6 whitespace-nowrap">
                Nuestra Historia
              </div>
              <h2 className="text-3xl md:text-6xl font-bold text-gray-900 mb-4 md:mb-6 leading-tight">
                Moda que<br />Inspira
              </h2>
              <p className="text-sm md:text-base text-gray-600 leading-loose mb-6 md:mb-8" style={{ lineHeight: '1.7' }}>
                En NIN Fashion, creemos que cada mujer merece sentirse segura y hermosa. 
                Nuestra misión es ofrecer prendas de alta calidad que combinen elegancia, 
                comodidad y estilo contemporáneo. Cada pieza es cuidadosamente seleccionada 
                para reflejar las últimas tendencias mientras mantiene la atemporalidad que 
                define a la mujer moderna.
              </p>
              <Link
                to="/catalogo"
                className="inline-flex items-center justify-between bg-[#F2C4CE] hover:bg-[#e8adb8] transition-colors rounded-2xl px-5 md:px-6 py-3 md:py-4 text-left group w-full md:w-64 whitespace-nowrap"
              >
                <span className="font-medium text-gray-900 text-sm md:text-base">Explorar Colección</span>
                <i className="ri-arrow-right-up-line text-lg md:text-xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform text-gray-900"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-24 px-4 md:px-8 bg-amber-50/30">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-serif text-gray-900 mb-6 md:mb-8">"Testimonios"</h2>
          
          <div className="inline-flex items-center gap-2 bg-gray-900 text-white px-3 md:px-4 py-1.5 md:py-2 rounded-full mb-6 md:mb-8">
            <i className="ri-star-fill text-yellow-400 text-sm md:text-base"></i>
            <span className="font-medium text-sm md:text-base">4.9</span>
          </div>

          <blockquote className="text-lg md:text-2xl font-serif text-gray-800 mb-6 md:mb-8 leading-relaxed px-2">
            "La calidad de las prendas de NIN es excepcional. Cada pieza que he comprado 
            se ha convertido en una favorita en mi guardarropa. El servicio al cliente 
            es impecable y la experiencia de compra es simplemente maravillosa."
          </blockquote>

          <div className="flex items-center justify-center gap-3 md:gap-4">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gray-300 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20portrait%20of%20elegant%20woman%20smiling%20with%20natural%20lighting%20and%20clean%20background%2C%20confident%20modern%20style%2C%20headshot%20photography&width=100&height=100&seq=testimonial1&orientation=squarish"
                alt="Cliente"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="text-left">
              <p className="font-medium text-gray-900 text-sm md:text-base">María González</p>
              <p className="text-xs md:text-sm text-gray-600">Cliente Frecuente</p>
            </div>
          </div>

          <div className="flex justify-center gap-2 md:gap-3 mt-8 md:mt-12">
            <button className="w-10 h-10 md:w-12 md:h-12 rounded-full border-2 border-gray-300 flex items-center justify-center hover:bg-gray-100 transition-colors" aria-label="Anterior">
              <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
            </button>
            <button className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-gray-900 text-white flex items-center justify-center hover:bg-gray-800 transition-colors" aria-label="Siguiente">
              <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
            </button>
          </div>
        </div>
      </section>

      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20fashion%20shopping%20scene%20with%20warm%20golden%20lighting%20and%20sophisticated%20ambiance%2C%20luxury%20retail%20experience%2C%20modern%20women%20clothing%20display%2C%20professional%20photography%2C%20inviting%20atmosphere&width=1920&height=1080&seq=cta1&orientation=landscape"
          alt="Comprar Ahora"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40"></div>
        
        <div className="relative z-10 text-center text-white px-4 md:px-8">
          <h2 className="text-3xl md:text-7xl font-bold tracking-widest mb-4 md:mb-6">NUEVA TEMPORADA</h2>
          <p className="text-sm md:text-xl font-light mb-8 md:mb-12 max-w-2xl mx-auto leading-relaxed">
            Descubre las últimas tendencias y renueva tu guardarropa<br className="hidden md:block" />
            con nuestras colecciones exclusivas
          </p>
          <Link
            to="/catalogo"
            className="inline-flex items-center gap-3 md:gap-4 bg-[#F2C4CE] text-gray-900 px-6 md:px-8 py-3 md:py-4 rounded-full hover:bg-[#e8adb8] transition-colors group whitespace-nowrap"
          >
            <div className="w-8 h-8 md:w-10 md:h-10 bg-white/60 rounded-full flex items-center justify-center">
              <i className="ri-shopping-bag-line text-base md:text-lg text-gray-900"></i>
            </div>
            <span className="text-xs md:text-sm font-medium tracking-wider">COMPRAR AHORA</span>
            <i className="ri-arrow-right-up-line text-lg md:text-xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}